import { render, staticRenderFns } from "./Policy.vue?vue&type=template&id=59ea0ce5&scoped=true&"
var script = {}
import style0 from "./Policy.vue?vue&type=style&index=0&id=59ea0ce5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ea0ce5",
  null
  
)

export default component.exports